<script setup>
import { BModal, BFormInput,  BFormTextarea, BFormSelect, BRow, BCol, BButton } from 'bootstrap-vue-next'
import { defineModel,ref } from 'vue'

const modal = defineModel()

const categoryVal = ref('-')
</script>

<template>
    <BModal id="modal-tall" size="lg" v-model="modal" centered title="Inventory" @update:modelValue="updateModal"> 
        <div class="d-flex flex-column gap-3">
            <BFormInput type="text" placeholder="Name"></BFormInput>
            <BRow>
                <BCol>
                    <BFormSelect class=" form-control" v-model="categoryVal" :options="theType"></BFormSelect>
                </BCol>
                <BCol>
                    <BFormInput type="number"></BFormInput>
                </BCol>
            </BRow>
            <BFormTextarea type="text-field" placeholder="Remark"></BFormTextarea>
        </div>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="mr-2">Save</BButton>
                <BButton variant="danger">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
const theType = [
    { value: '-', text: 'Choose Category' },
    { value: 'product', text: 'Product' },
    { value: 'Item', text: 'Item' },
]


</script>